import { createReducer } from "@reduxjs/toolkit";
import { IClientHouseState } from "./types";
import * as actions from "./actions";
import { StoreState } from "../storeState";
import { STORAGE_RESET } from "../storeReset";

const initialState = {
  data: null,
  state: StoreState.None,
} as IClientHouseState;

export const clientHouseReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.clientHouseFetchRequest, (state) => ({
      ...state,
      state: StoreState.Loading,
    }))
    .addCase(actions.clientHouseFetchSuccess, (state, action) => ({
      ...state,
      state: StoreState.Loaded,
      data: action.payload,
    }))
    .addCase(actions.clientHouseFetchError, (state) => ({
      ...state,
      state: StoreState.Error,
    }))
    .addCase(actions.clientHouseReset, () => initialState)
    .addCase(STORAGE_RESET, () => initialState)
);
